import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  bg?: 'cream' | 'white';
  className?: string;
  id?: string;
}
export function Section({
  children,
  bg = 'cream',
  className = '',
  id
}: SectionProps) {
  const bgColor = bg === 'cream' ? 'bg-[#FFF8F0]' : 'bg-white';
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${bgColor} ${className}`} data-id="element-200">
      <motion.div className="max-w-4xl mx-auto" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-201">
        {children}
      </motion.div>
    </section>;
}